import type { Dispatch } from 'redux';

import { actionResetAdBudget } from 'src/app/v1/state/modules/session/adBudget';
import { actionResetAdvertiserId } from 'src/app/v1/state/modules/session/advertiserId';
import { actionResetAdvertiserName } from 'src/app/v1/state/modules/session/advertiserName';
import { actionResetBillToAgent } from 'src/app/v1/state/modules/session/billToAgent';
import { actionResetBillingAccountId } from 'src/app/v1/state/modules/session/billingAccountId';
import { actionResetBuyUpSell } from 'src/app/v1/state/modules/session/buyUpSell';
import { actionResetCart } from 'src/app/v1/state/modules/session/cart';
import { actionResetCategoryText } from 'src/app/v1/state/modules/session/categoryText';
import { actionResetContractBalance } from 'src/app/v1/state/modules/session/contractBalance';
import { actionResetCreateJobAndOrderRequest } from 'src/app/v1/state/modules/session/createJobAndOrderRequest';
import { actionResetDraftId } from 'src/app/v1/state/modules/session/draftId';
import { actionResetDraftStatus } from 'src/app/v1/state/modules/session/draftStatus';
import { actionResetEditFlowCheckout } from 'src/app/v1/state/modules/session/editFlowCheckout';
import { actionResetHasReviewedGeneratedContent } from 'src/app/v1/state/modules/session/hasReviewedGeneratedContent';
import { actionResetHirerAccount } from 'src/app/v1/state/modules/session/hirerAccount';
import { actionResetHirerIsNew } from 'src/app/v1/state/modules/session/hirerIsNew';
import { actionResetInteractionId } from 'src/app/v1/state/modules/session/interactionId';
import { actionResetIsEmailVerified } from 'src/app/v1/state/modules/session/isEmailVerified';
import { actionResetIsJobPosted } from 'src/app/v1/state/modules/session/isJobPosted';
import { actionResetIsJobPostedEventPublished } from 'src/app/v1/state/modules/session/isJobPostedEventPublished';
import { actionResetIsPaymentInProgress } from 'src/app/v1/state/modules/session/isPaymentInProgress';
import { actionResetJob } from 'src/app/v1/state/modules/session/job';
import { actionResetJobLocationCountry } from 'src/app/v1/state/modules/session/jobLocationCountry';
import { actionResetJobLocationDisplayDescription } from 'src/app/v1/state/modules/session/jobLocationDisplayDescription';
import { actionResetJobLocationText } from 'src/app/v1/state/modules/session/jobLocationText';
import { actionResetJobOrderId } from 'src/app/v1/state/modules/session/jobOrderId';
import { actionResetNotificationsSetting } from 'src/app/v1/state/modules/session/notificationsSetting';
import { actionResetPageId } from 'src/app/v1/state/modules/session/pageId';
import { actionResetPaymentType } from 'src/app/v1/state/modules/session/paymentType';
import { actionResetPhoneNumber } from 'src/app/v1/state/modules/session/phoneNumber';
import { actionResetPostChannel } from 'src/app/v1/state/modules/session/postChannel';
import { actionResetPostType } from 'src/app/v1/state/modules/session/postType';
import { actionResetPostalAddress } from 'src/app/v1/state/modules/session/postalAddress';
import { actionResetProductCurrency } from 'src/app/v1/state/modules/session/productCurrency';
import { actionResetProductDisplayName } from 'src/app/v1/state/modules/session/productDisplayName';
import { actionResetProductFeatures } from 'src/app/v1/state/modules/session/productFeatures';
import { actionResetProductSet } from 'src/app/v1/state/modules/session/productSet';
import { actionResetProductSetStatus } from 'src/app/v1/state/modules/session/productSetStatus';
import { actionResetRrFailedToSave } from 'src/app/v1/state/modules/session/rrFailedToSave';
import { actionResetSeekAdvertiserId } from 'src/app/v1/state/modules/session/seekAdvertiserId';
import { actionResetSeekClassificationId } from 'src/app/v1/state/modules/session/seekClassificationId';
import { actionResetSeekSubClassificationId } from 'src/app/v1/state/modules/session/seekSubClassificationId';
import { actionResetSelectedRRQuestions } from 'src/app/v1/state/modules/session/selectedRRQuestions';
import { actionResetSourceJobId } from 'src/app/v1/state/modules/session/sourceJobId';
import { actionResetSubCategoryText } from 'src/app/v1/state/modules/session/subCategoryText';
import { actionResetUserEmailAddress } from 'src/app/v1/state/modules/session/userEmailAddress';
import { actionResetUserFirstName } from 'src/app/v1/state/modules/session/userFirstName';
import { actionResetUserId } from 'src/app/v1/state/modules/session/userId';
import { actionResetUserLastName } from 'src/app/v1/state/modules/session/userLastName';
import { actionResetUserPermissions } from 'src/app/v1/state/modules/session/userPermissions';

export default () => (dispatch: Dispatch) => {
  dispatch(actionResetAdBudget());
  dispatch(actionResetAdvertiserId());
  dispatch(actionResetAdvertiserName());
  dispatch(actionResetBillToAgent());
  dispatch(actionResetBuyUpSell());
  dispatch(actionResetCart());
  dispatch(actionResetCategoryText());
  dispatch(actionResetContractBalance());
  dispatch(actionResetCreateJobAndOrderRequest());
  dispatch(actionResetDraftId());
  dispatch(actionResetDraftStatus());
  dispatch(actionResetEditFlowCheckout());
  dispatch(actionResetHasReviewedGeneratedContent());
  dispatch(actionResetHirerAccount());
  dispatch(actionResetBillingAccountId());
  dispatch(actionResetHirerIsNew());
  dispatch(actionResetInteractionId());
  dispatch(actionResetIsEmailVerified());
  dispatch(actionResetIsJobPosted());
  dispatch(actionResetIsPaymentInProgress());
  dispatch(actionResetIsJobPostedEventPublished());
  dispatch(actionResetJob());
  dispatch(actionResetJobLocationCountry());
  dispatch(actionResetJobLocationDisplayDescription());
  dispatch(actionResetJobLocationText());
  dispatch(actionResetJobOrderId());
  dispatch(actionResetNotificationsSetting());
  dispatch(actionResetPageId());
  dispatch(actionResetPaymentType());
  dispatch(actionResetPhoneNumber());
  dispatch(actionResetPostalAddress());
  dispatch(actionResetProductDisplayName());
  dispatch(actionResetProductSet());
  dispatch(actionResetProductSetStatus());
  dispatch(actionResetRrFailedToSave());
  dispatch(actionResetSeekAdvertiserId());
  dispatch(actionResetSeekClassificationId());
  dispatch(actionResetSeekSubClassificationId());
  dispatch(actionResetPostChannel());
  dispatch(actionResetPostType());
  dispatch(actionResetProductCurrency());
  dispatch(actionResetProductFeatures());
  dispatch(actionResetSelectedRRQuestions());
  dispatch(actionResetSourceJobId());
  dispatch(actionResetSubCategoryText());
  dispatch(actionResetUserEmailAddress());
  dispatch(actionResetUserFirstName());
  dispatch(actionResetUserLastName());
  dispatch(actionResetUserId());
  dispatch(actionResetUserPermissions());
};
